enum ProductRowOptionalStateEnum {
	mandatory = 'mandatory',
	addable = 'addable',
	removableFromList = 'removableFromList',
	removableFromTab = 'removableFromTab'
}

export default ProductRowOptionalStateEnum;
